module.exports = __webpack_public_path__ + "static/media/ljubljana-28.447a78a9.jpg";